/* Title 组件，常用语详情页一组属性的分类标题
 *
 * @Author: fan.li@zuolin.com
 * @Date: 2019-08-27 16:31:23
 * @Last Modified by: fan.li@zuolin.com
 * @Last Modified time: 2019-12-31 14:25:22
 */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './index.less';

const Title = (props) => {
	const { title, isLarge, marginTop, marginBottom, style, className, linerMargin } = props;
	const prefixCls = 'eh-title-component';

	const wrapCls = classnames({
		[`${prefixCls}`]: true,
		[`${className}`]: true,
		[`${prefixCls}-large`]: isLarge,
	});

	return (
		<div className={wrapCls} style={{ marginTop, marginBottom, ...style }} >
			<span className={`${prefixCls}-before`} style={{ marginRight: linerMargin }} />
		  <span className={`${prefixCls}-label`} >{title}</span>
		</div>
	);
};

Title.defaultProps = {
	className: '',
	linerMargin: 20,
	style: {},
};

Title.propTypes = {
	title: PropTypes.string, // 标题
	isLarge: PropTypes.bool, // 是否为大标题
	linerMargin: PropTypes.number, // 内部间距
	marginTop: PropTypes.number, // 上间距
	marginBottom: PropTypes.number, // 下间距
	style: PropTypes.object, // 样式
	className: PropTypes.string, // 类名
};

export default Title;
